import PropTypes from 'prop-types';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import CustomSwitch from './Switch/custom-switch.js';

function SwitchwithDetails({ text, subtext, name, data, setData }) {
	const theme = useTheme();
	const isMobile = useMediaQuery('(max-width:768px)');

	return (
		<div>
			<Box
				display={'flex'}
				alignItems={'center'}
				width={'100%'}
				justifyContent={'space-between'}
			>
				<Box>
					{text && (
						<div
							className={isMobile ? 'semiBold13' : 'medium4'}
							style={{ marginBottom: theme.spacing(1) }}
						>
							{text}
						</div>
					)}
					<div
						className={
							isMobile ? 'medium7 grey-textcolor' : 'medium5 grey-textcolor'
						}
					>
						{subtext}
					</div>
				</Box>
				<CustomSwitch name={name} data={data} setData={setData} />
			</Box>
		</div>
	);
}

export default SwitchwithDetails;

SwitchwithDetails.propTypes = {
	text: PropTypes.any,
	subtext: PropTypes.any,
	name: PropTypes.any,
	data: PropTypes.any,
	setData: PropTypes.any
};
